import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Map } from 'immutable';
import moment from 'moment';
import { AlertsActions } from '../../../../store';
import { CommentType } from '../../../../store/alerts/types';

import './InformationComments.css';

interface Props {
  commentApiLocation: string;
  comments: CommentType[];
  updateComment(comment: string, apiLocation: string): Promise<any>;
  addComment(comment: string, apiLocation: string): Promise<any>;
  triggerRefetch(): void;
}

interface State {
  newComment: string;
  editedComment: Map<string, string>;
  isEditing: boolean;
}

export class InformationComments extends Component<Props, State> {
  state = {
    newComment: '',
    editedComment: Map() as Map<string, string>,
    isEditing: false,
  };

  setEditingState = (isEditing: boolean) => {
    this.setState((state) => ({
      ...state,
      isEditing,
    }));
  };

  handleTextChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
    e.persist();
    const { name, value } = e.target;

    this.setState((state) => ({
      ...state,
      [name]: value,
    }));
  };

  render() {
    const { comments } = this.props;
    const { newComment, editedComment } = this.state;

    return (
      <div className="information-comments">
        {comments.map((commentItem) => {
          const { comment, created, uid_hash, user } = commentItem;

          const isEditing = editedComment.has(uid_hash);

          return (
            <div key={uid_hash} className="comment-item-box">
              <div className="comment-item-box__top-row">
                <div>{user}</div>
                <div>{moment(created).format('LLL')}</div>
              </div>
              <div className="comment-item-box__comment">{comment}</div>
            </div>
          );
        })}
      </div>
    );
  }
}

const mapDispatchToProps = {
  updateComment: AlertsActions.updateComment,
  addComment: AlertsActions.addComment,
};

export const ConnectedInformationComments = connect(null, mapDispatchToProps)(InformationComments);
